"use strict";

import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import Webservices from "@/Webservices";

var ws = new Webservices();

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: "data",
  storage: localStorage
});

const rules = {
  questions: {
    list: true,
    edit: true
  },
  videos: {
    list: true,
    edit: true
  },
  vouchers: {
    list: true,
    edit: true
  },
  dashboard: {
    list: true
  },
  acessos: {
    list: true
  },
  radios: {
    list: true
  },
  emails: {
    list: true
  }
};

export default new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: {
    openGroup: false,
    activeGroup: "",
    loggedIn: false,
    currentPage: "",
    currentModal: undefined,
    name: "",
    email: "",
    userId: "",
    rules: rules,
    token: "",
    isADM: false,
    isROOT: false,
    group: undefined,
    groupName: "",
    groupId: "",
    photo: "",
    clients: [],
    client: {},
    theme: true,
    ageRanges: [
      {
        id: 0,
        label: "0 a 14",
        limits: [0, 14]
      },
      {
        id: 1,
        label: "15 a 20",
        limits: [15, 20]
      },
      {
        id: 2,
        label: "21 a 30",
        limits: [21, 30]
      },
      {
        id: 3,
        label: "31 a 40",
        limits: [31, 40]
      },
      {
        id: 4,
        label: "41 a 50",
        limits: [41, 50]
      },
      {
        id: 5,
        label: "51 a 60",
        limits: [51, 60]
      },
      {
        id: 6,
        label: "61 ou mais",
        limits: [61, 120]
      },
      {
        id: 7,
        label: "Não informado"
      }
    ]
  },
  mutations: {
    LOGIN(state, payload) {
      state.token = payload.id;
      state.loggedIn = true;
      state.userId = payload.userId;
    },
    LOGGED_IN(state, payload) {
      state.currentPage = "Dashboard";
      state.currentModal = undefined;
      state.name = payload.name;
      state.email = payload.email;
      state.rules = payload.rules;
      state.isADM = payload.is_adm;
      state.photo = payload.photo;
      state.theme = payload.theme;
      state.group = payload.group;
      state.isROOT =
        payload.hasOwnProperty("group") && payload.group.text == "ROOT";
      state.groupName = payload.hasOwnProperty("group")
        ? payload.group.text
        : "";
      state.groupId = payload.hasOwnProperty("group") ? payload.group.id : null;
      state.clients = [];
    },
    LOGGED_OUT(state) {
      state.group_client_await = false;
      state.currentPage = "login";
      state.currentModal = undefined;
      state.group_selected_clients = null;
      state.loggedIn = false;
      state.name = "";
      state.email = "";
      state.userId = "";
      state.rules = rules;
      state.token = "";
      state.isADM = false;
      state.client = {};
      state.photo = "";
      state.theme = true;
      state.isROOT = false;
      state.group = undefined;
      state.groupName = "";
      state.groupId = undefined;
      state.clients = [];
      ws.removeToken();
    },
    SET_CLIENTS_LIST(state, payload) {
      state.clients = payload;
    },
    SELECT_CLIENT(state, payload) {
      state.client = payload;
    }
  },
  actions: {
    login({ commit }, payload) {
      commit("LOGIN", payload);
    },
    logout({ commit }) {
      commit("LOGGED_OUT");
    },
    loggedIn({ commit }, payload) {
      commit("LOGGED_IN", payload);
    },
    setClientsList({ commit }, payload) {
      commit("SET_CLIENTS_LIST", payload);
    },
    selectClient({ commit }, payload) {
      commit("SELECT_CLIENT", payload);
    }
  },
  getters: {
    isLoggedIn: state => state.loggedIn,
    getCurrentPage: state => state.currentPage,
    getCurrentModal: state => state.currentModal,
    getName: state => state.name,
    getClientID: state => (state.client ? state.client.controller_id : null),
    getControllerId: state =>
      state.client ? state.client.controller_id : null,
    getGroupID: state =>
      state.group_selected ? state.group_selected.id : null,
    getGroupClients: state =>
      state.group_selected_clients ? state.group_selected_clients : null,
    getRadioPrefix: state => state.client.radio_prefix,
    getID: state => (state.client ? state.client.id : null),
    isADM: state => state.isADM,
    getPhoto: state => state.photo,
    isDark: state => state.theme,
    ageRanges: state => state.ageRanges,
    getClientName: state => state.client.name,
    getClientLogo: state => state.client.logo_Base64,
    isROOT: state => (state.group && state.group.text == "ROOT" ? true : false),
    getGroup: state => state.group,
    getGroupName: state => state.groupText,
    getGroupId: state => state.groupId,
    getUserId: state => state.userId,
    getRules: state => state.rules || rules,
    getClients: state => state.clients || [],
    getToken: state => state.token,
    getIdVagalox: state => (state.client ? state.client.idVagalox : null),
    isMapActive: state => (state.client ? state.client.activeMap : null)
  }
});



// WEBPACK FOOTER //
// ./src/store.js